if (!customElements.get('delivery-noshi-fields')) {
  customElements.define(
    'delivery-noshi-fields',
    class DeliveryNoshiFields extends HTMLElement {
      constructor() {
        super();
        this.dateField = this.querySelector('.delivery-date-field');
        this.dateInput = this.querySelector('.delivery-date-input');
        this.noshiSelect = this.querySelector('.noshi-select');
        this.noshiNameField = this.querySelector('.noshi-name-field');

        this.optionName = (this.dataset.optionName || '').trim();
        this.showValue = (this.dataset.showValue || '').trim();

        this.setMinDate();
        this.toggleNoshiName();

        this.onVariantOptionChange = this.onVariantOptionChange.bind(this);
        document.addEventListener('change', this.onVariantOptionChange);

        if (this.noshiSelect) {
          this.noshiSelect.addEventListener('change', () => this.toggleNoshiName());
        }
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onVariantOptionChange);
      }

      normalizeOptionName(name) {
        if (!name) return '';
        const trimmed = name.trim();
        const bracketMatch = trimmed.match(/^options\[(.+)\]$/);
        if (bracketMatch) return bracketMatch[1];
        return trimmed.replace(/-\d+$/, '');
      }

      onVariantOptionChange(event) {
        const target = event.target;
        if (!target || !this.optionName) return;

        const targetOptionName = this.normalizeOptionName(target.name);
        if (targetOptionName !== this.optionName) return;

        const isMatch = target.value === this.showValue;
        this.toggleDateField(isMatch);
      }

      toggleDateField(show) {
        if (!this.dateField || !this.dateInput) return;
        this.dateField.hidden = !show;
        this.dateInput.disabled = !show;
        if (show) {
          this.dateInput.required = true;
          if (!this.dateInput.value) this.setMinDate();
        } else {
          this.dateInput.required = false;
          this.dateInput.value = '';
        }
      }

      setMinDate() {
        let minDate = this.dataset.minDate;
        if (!minDate) {
          const leadDays = parseInt(this.dataset.leadDays || '7', 10);
          const d = new Date();
          d.setDate(d.getDate() + leadDays);
          minDate = d.toISOString().split('T')[0];
        }
        if (this.dateInput) {
          this.dateInput.min = minDate;
          if (!this.dateInput.disabled) this.dateInput.value = minDate;
        }
      }

      toggleNoshiName() {
        if (!this.noshiSelect || !this.noshiNameField) return;
        const firstOption = this.noshiSelect.options[0]?.value;
        this.noshiNameField.hidden = this.noshiSelect.value === firstOption;
      }
    }
  );
}
